import React, { useEffect, useState } from "react";
import "./Product_details_swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import Best_seller_heart from "../../common-components/product_card/Best_seller_heart/Best_seller_heart";

function Product_details_swiper({ product }) {
  const [activeMedia, setActiveMedia] = useState({});

  useEffect(() => {
    if (product) {
      setActiveMedia({
        type: "image",
        file: product?.image
      });
    }
  }, [product]);
  const isVideo = /\.(mp4|webm|ogg|mov|avi)$/i.test(activeMedia?.file || "");
  return (
    <section className="Product_details_swiper">

      {/* MAIN DISPLAY */}
      <div className="main_img_holder">
        <div className="img_holder">


          {isVideo ? (
            <video
              className="Product_img active_product_img"
              controls
              autoPlay
              muted
            >
              <source
                src={process.env.REACT_APP_IMG_URL + activeMedia.file}
                type="video/mp4"
              />
            </video>
          ) : (
            <img
              className="Product_img active_product_img"
              src={process.env.REACT_APP_IMG_URL + activeMedia.file}
              alt="Product"
            />
          )}

          {/* {activeMedia?.type === "video" ? (
            <video
              className="Product_img active_product_img"
              controls
              autoPlay
              muted
            >
              <source
                src={process.env.REACT_APP_IMG_URL + activeMedia.file}
                type="video/mp4"
              />
            </video>
          ) : (
            <img
              className="Product_img active_product_img"
              src={process.env.REACT_APP_IMG_URL + activeMedia.file}
              alt="Product"
            />
          )} */}

        </div>

        <div className="wishlist_div">
          <Best_seller_heart product={product} />
        </div>
      </div>

      {/* THUMBNAILS */}
      <div className="swiper_holder">
        <Swiper slidesPerView={5} spaceBetween={10}>

          {/* {product?.Product_Images?.map((val, index) => (
            <SwiperSlide
              key={index}
              onClick={() =>
                setActiveMedia({
                  type: val.type,
                  file: val.image
                })
              }
            >
              <div className="img_holder">

                {val.type === "video" ? (
                  <video className="Product_img">
                    <source
                      src={process.env.REACT_APP_IMG_URL + val.image}
                      type="video/mp4"
                    />
                  </video>
                ) : (
                  <img
                    className="Product_img"
                    src={process.env.REACT_APP_IMG_URL + val.image}
                    alt="thumb"
                  />
                )}

              </div>
            </SwiperSlide>
          ))} */}
          {product?.Product_Images?.map((val, index) => {
            const filePath = val?.image || "";
            const isVideo = /\.(mp4|webm|ogg|mov|avi)$/i.test(filePath);

            return (
              <SwiperSlide
                key={index}
                onClick={() =>
                  setActiveMedia({
                    file: filePath
                  })
                }
              >
                <div className="img_holder">
                  {isVideo ? (
                    <video className="Product_img">
                      <source
                        src={process.env.REACT_APP_IMG_URL + filePath}
                        type={`video/${filePath.split(".").pop()}`}
                      />
                    </video>
                  ) : (
                    <img
                      className="Product_img"
                      src={process.env.REACT_APP_IMG_URL + filePath}
                      alt="thumb"
                    />
                  )}
                </div>
              </SwiperSlide>
            );
          })}

        </Swiper>
      </div>
    </section>
  );
}

export default Product_details_swiper;
